/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
// reactstrap components
import NotificationAlert from "react-notification-alert";
import { Tabs, Tab } from "react-bootstrap";
// import Modal from 'react-modal';
// import "cropperjs/dist/cropper.css";
import {  
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,
    Col  
} from "reactstrap";
import Mailreg from './Mailreg';

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
let session = {};
let notificationAlert;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding:'0.25rem',
        width:'85%',
        borderRadius:'15px',
        maxWidth:'1000px',
        fontWeight:'bold'
    }
};

function Sendmail(){
    notificationAlert = React.useRef();
    const history = useHistory();

    const [cropData, setCropData] = useState("#");
    const [cropper, setCropper] = useState();
    const [modalIsOpen, setIsOpen]    = useState(false);

    session = JSON.parse(window.sessionStorage.getItem('sessions')); 

    useEffect(() => {
    
        if(session === null){      
          window.location = '/';
        }  
    
    }, []);

    return (
        <>
            <div className="content px-0 pb-0 coach-user-content">
                <NotificationAlert ref={notificationAlert} />
                <div className="row px-0 mx-0">
                    <div className="col-12 px-0">
                        <Card className="card-user mb-0">
                            <Col md="12" className="colp playerInfoTab">
                                <Tabs fill defaultActiveKey="reg" id="uncontrolled-tab-example">
                                    <Tab
                                        eventKey="reg"
                                        title="メール配信"
                                        mountOnEnter // <<<
                                        unmountOnExit={false} // <<<
                                    >
                                        <Mailreg />
                                    </Tab>
                                </Tabs>
                            </Col>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sendmail;